// crawl.proto — operator surface for the ingestion pipeline.
//
// Crawling is a days-long, rate-limited, resumable process against four APIs
// with wildly different budgets, so it needs to be observable and steerable
// while it runs, not a fire-and-forget script. These RPCs are what the admin
// UI and the CLI both drive.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file amrec/v1/crawl.proto (package amrec.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Source } from "./common_pb";
import { file_amrec_v1_common } from "./common_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file amrec/v1/crawl.proto.
 */
export const file_amrec_v1_crawl: GenFile = /*@__PURE__*/
  fileDesc("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", [file_amrec_v1_common, file_google_protobuf_timestamp]);

/**
 * @generated from message amrec.v1.EnqueueBackfillRequest
 */
export type EnqueueBackfillRequest = Message<"amrec.v1.EnqueueBackfillRequest"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: amrec.v1.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * Cap the enqueue. 0 = the whole catalog. Bounded runs are how a new adapter
   * gets validated before it's pointed at 90k titles.
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * Re-enqueue entities already in bronze. Off by default: the normal reason
   * to re-run a backfill is to pick up what was missed, not to re-fetch what
   * succeeded.
   *
   * @generated from field: bool force = 4;
   */
  force: boolean;

  /**
   * @generated from field: int32 priority = 5;
   */
  priority: number;
};

/**
 * Describes the message amrec.v1.EnqueueBackfillRequest.
 * Use `create(EnqueueBackfillRequestSchema)` to create a new message.
 */
export const EnqueueBackfillRequestSchema: GenMessage<EnqueueBackfillRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 0);

/**
 * @generated from message amrec.v1.EnqueueBackfillResponse
 */
export type EnqueueBackfillResponse = Message<"amrec.v1.EnqueueBackfillResponse"> & {
  /**
   * @generated from field: int32 jobs_enqueued = 1;
   */
  jobsEnqueued: number;
};

/**
 * Describes the message amrec.v1.EnqueueBackfillResponse.
 * Use `create(EnqueueBackfillResponseSchema)` to create a new message.
 */
export const EnqueueBackfillResponseSchema: GenMessage<EnqueueBackfillResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 1);

/**
 * RenormalizeRequest re-derives the typed tables from bronze with zero network
 * calls. This is the payoff of storing raw responses: schema and parser
 * changes replay over cached documents in minutes instead of re-crawling for
 * days.
 *
 * @generated from message amrec.v1.RenormalizeRequest
 */
export type RenormalizeRequest = Message<"amrec.v1.RenormalizeRequest"> & {
  /**
   * @generated from field: repeated amrec.v1.Source sources = 1;
   */
  sources: Source[];

  /**
   * @generated from field: repeated amrec.v1.EntityType entity_types = 2;
   */
  entityTypes: EntityType[];

  /**
   * Only re-parse documents fetched after this. Empty = everything.
   *
   * @generated from field: google.protobuf.Timestamp since = 3;
   */
  since?: Timestamp | undefined;

  /**
   * Parse and report, write nothing. Use before a risky parser change.
   *
   * @generated from field: bool dry_run = 4;
   */
  dryRun: boolean;
};

/**
 * Describes the message amrec.v1.RenormalizeRequest.
 * Use `create(RenormalizeRequestSchema)` to create a new message.
 */
export const RenormalizeRequestSchema: GenMessage<RenormalizeRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 2);

/**
 * @generated from message amrec.v1.RenormalizeResponse
 */
export type RenormalizeResponse = Message<"amrec.v1.RenormalizeResponse"> & {
  /**
   * @generated from field: int64 documents_read = 1;
   */
  documentsRead: bigint;

  /**
   * @generated from field: int64 entities_written = 2;
   */
  entitiesWritten: bigint;

  /**
   * @generated from field: int64 parse_errors = 3;
   */
  parseErrors: bigint;

  /**
   * @generated from field: repeated string sample_errors = 4;
   */
  sampleErrors: string[];
};

/**
 * Describes the message amrec.v1.RenormalizeResponse.
 * Use `create(RenormalizeResponseSchema)` to create a new message.
 */
export const RenormalizeResponseSchema: GenMessage<RenormalizeResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 3);

/**
 * @generated from message amrec.v1.SourceStatus
 */
export type SourceStatus = Message<"amrec.v1.SourceStatus"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: int64 pending_jobs = 2;
   */
  pendingJobs: bigint;

  /**
   * @generated from field: int64 running_jobs = 3;
   */
  runningJobs: bigint;

  /**
   * @generated from field: int64 dead_jobs = 4;
   */
  deadJobs: bigint;

  /**
   * @generated from field: int64 raw_documents = 5;
   */
  rawDocuments: bigint;

  /**
   * Observed, not configured — read back from the upstream rate-limit headers
   * so a degraded API (AniList has been running at a third of nominal) shows
   * up here rather than as mysterious slowness.
   *
   * @generated from field: double observed_requests_per_min = 6;
   */
  observedRequestsPerMin: number;

  /**
   * @generated from field: int32 rate_limit_remaining = 7;
   */
  rateLimitRemaining: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_success = 8;
   */
  lastSuccess?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp backoff_until = 9;
   */
  backoffUntil?: Timestamp | undefined;

  /**
   * @generated from field: string last_error = 10;
   */
  lastError: string;
};

/**
 * Describes the message amrec.v1.SourceStatus.
 * Use `create(SourceStatusSchema)` to create a new message.
 */
export const SourceStatusSchema: GenMessage<SourceStatus> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 4);

/**
 * @generated from message amrec.v1.GetCrawlStatusRequest
 */
export type GetCrawlStatusRequest = Message<"amrec.v1.GetCrawlStatusRequest"> & {
};

/**
 * Describes the message amrec.v1.GetCrawlStatusRequest.
 * Use `create(GetCrawlStatusRequestSchema)` to create a new message.
 */
export const GetCrawlStatusRequestSchema: GenMessage<GetCrawlStatusRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 5);

/**
 * @generated from message amrec.v1.GetCrawlStatusResponse
 */
export type GetCrawlStatusResponse = Message<"amrec.v1.GetCrawlStatusResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.SourceStatus sources = 1;
   */
  sources: SourceStatus[];

  /**
   * @generated from field: int64 total_works = 2;
   */
  totalWorks: bigint;

  /**
   * @generated from field: int64 total_characters = 3;
   */
  totalCharacters: bigint;

  /**
   * @generated from field: int64 total_people = 4;
   */
  totalPeople: bigint;

  /**
   * @generated from field: int64 works_with_text_embedding = 5;
   */
  worksWithTextEmbedding: bigint;

  /**
   * @generated from field: int64 works_with_image_embedding = 6;
   */
  worksWithImageEmbedding: bigint;

  /**
   * @generated from field: int64 unresolved_candidates = 7;
   */
  unresolvedCandidates: bigint;
};

/**
 * Describes the message amrec.v1.GetCrawlStatusResponse.
 * Use `create(GetCrawlStatusResponseSchema)` to create a new message.
 */
export const GetCrawlStatusResponseSchema: GenMessage<GetCrawlStatusResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 6);

/**
 * @generated from message amrec.v1.ListJobsRequest
 */
export type ListJobsRequest = Message<"amrec.v1.ListJobsRequest"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: amrec.v1.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * @generated from field: amrec.v1.JobState state = 3;
   */
  state: JobState;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken: string;
};

/**
 * Describes the message amrec.v1.ListJobsRequest.
 * Use `create(ListJobsRequestSchema)` to create a new message.
 */
export const ListJobsRequestSchema: GenMessage<ListJobsRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 7);

/**
 * @generated from message amrec.v1.CrawlJob
 */
export type CrawlJob = Message<"amrec.v1.CrawlJob"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: amrec.v1.Source source = 2;
   */
  source: Source;

  /**
   * @generated from field: amrec.v1.EntityType entity_type = 3;
   */
  entityType: EntityType;

  /**
   * @generated from field: string target_id = 4;
   */
  targetId: string;

  /**
   * @generated from field: amrec.v1.JobState state = 5;
   */
  state: JobState;

  /**
   * @generated from field: int32 priority = 6;
   */
  priority: number;

  /**
   * @generated from field: int32 attempts = 7;
   */
  attempts: number;

  /**
   * @generated from field: string last_error = 8;
   */
  lastError: string;

  /**
   * @generated from field: google.protobuf.Timestamp run_after = 9;
   */
  runAfter?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message amrec.v1.CrawlJob.
 * Use `create(CrawlJobSchema)` to create a new message.
 */
export const CrawlJobSchema: GenMessage<CrawlJob> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 8);

/**
 * @generated from message amrec.v1.ListJobsResponse
 */
export type ListJobsResponse = Message<"amrec.v1.ListJobsResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.CrawlJob jobs = 1;
   */
  jobs: CrawlJob[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message amrec.v1.ListJobsResponse.
 * Use `create(ListJobsResponseSchema)` to create a new message.
 */
export const ListJobsResponseSchema: GenMessage<ListJobsResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 9);

/**
 * RetryDeadJobsRequest resurrects DEAD jobs after an adapter fix.
 *
 * @generated from message amrec.v1.RetryDeadJobsRequest
 */
export type RetryDeadJobsRequest = Message<"amrec.v1.RetryDeadJobsRequest"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: amrec.v1.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message amrec.v1.RetryDeadJobsRequest.
 * Use `create(RetryDeadJobsRequestSchema)` to create a new message.
 */
export const RetryDeadJobsRequestSchema: GenMessage<RetryDeadJobsRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 10);

/**
 * @generated from message amrec.v1.RetryDeadJobsResponse
 */
export type RetryDeadJobsResponse = Message<"amrec.v1.RetryDeadJobsResponse"> & {
  /**
   * @generated from field: int32 jobs_reset = 1;
   */
  jobsReset: number;
};

/**
 * Describes the message amrec.v1.RetryDeadJobsResponse.
 * Use `create(RetryDeadJobsResponseSchema)` to create a new message.
 */
export const RetryDeadJobsResponseSchema: GenMessage<RetryDeadJobsResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 11);

/**
 * PauseSourceRequest stops scheduling for one source without stopping the
 * worker — for when an upstream is struggling and the polite thing is to back
 * off rather than to keep probing.
 *
 * @generated from message amrec.v1.PauseSourceRequest
 */
export type PauseSourceRequest = Message<"amrec.v1.PauseSourceRequest"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: bool paused = 2;
   */
  paused: boolean;
};

/**
 * Describes the message amrec.v1.PauseSourceRequest.
 * Use `create(PauseSourceRequestSchema)` to create a new message.
 */
export const PauseSourceRequestSchema: GenMessage<PauseSourceRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 12);

/**
 * @generated from message amrec.v1.PauseSourceResponse
 */
export type PauseSourceResponse = Message<"amrec.v1.PauseSourceResponse"> & {
  /**
   * @generated from field: bool paused = 1;
   */
  paused: boolean;
};

/**
 * Describes the message amrec.v1.PauseSourceResponse.
 * Use `create(PauseSourceResponseSchema)` to create a new message.
 */
export const PauseSourceResponseSchema: GenMessage<PauseSourceResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_crawl, 13);

/**
 * EntityType is the crawl target within a source. Kept separate from WorkKind
 * because it addresses upstream endpoints ("AniList characters"), not shelves.
 *
 * @generated from enum amrec.v1.EntityType
 */
export enum EntityType {
  /**
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_WORK = 1;
   */
  WORK = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_CHARACTER = 2;
   */
  CHARACTER = 2,

  /**
   * @generated from enum value: ENTITY_TYPE_PERSON = 3;
   */
  PERSON = 3,

  /**
   * @generated from enum value: ENTITY_TYPE_ORGANIZATION = 4;
   */
  ORGANIZATION = 4,

  /**
   * score/rank refresh only
   *
   * @generated from enum value: ENTITY_TYPE_STATS = 5;
   */
  STATS = 5,

  /**
   * image fetch + pHash + embed
   *
   * @generated from enum value: ENTITY_TYPE_COVER = 6;
   */
  COVER = 6,

  /**
   * "if you liked X" edges
   *
   * @generated from enum value: ENTITY_TYPE_RECOMMENDATION = 7;
   */
  RECOMMENDATION = 7,
}

/**
 * Describes the enum amrec.v1.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_amrec_v1_crawl, 0);

/**
 * @generated from enum amrec.v1.JobState
 */
export enum JobState {
  /**
   * @generated from enum value: JOB_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: JOB_STATE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: JOB_STATE_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: JOB_STATE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * Exhausted retries. Kept rather than deleted — a wall of DEAD jobs for one
   * source is the signal that an adapter broke against an upstream change.
   *
   * @generated from enum value: JOB_STATE_DEAD = 5;
   */
  DEAD = 5,
}

/**
 * Describes the enum amrec.v1.JobState.
 */
export const JobStateSchema: GenEnum<JobState> = /*@__PURE__*/
  enumDesc(file_amrec_v1_crawl, 1);

/**
 * @generated from service amrec.v1.CrawlService
 */
export const CrawlService: GenService<{
  /**
   * @generated from rpc amrec.v1.CrawlService.EnqueueBackfill
   */
  enqueueBackfill: {
    methodKind: "unary";
    input: typeof EnqueueBackfillRequestSchema;
    output: typeof EnqueueBackfillResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CrawlService.Renormalize
   */
  renormalize: {
    methodKind: "unary";
    input: typeof RenormalizeRequestSchema;
    output: typeof RenormalizeResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CrawlService.GetCrawlStatus
   */
  getCrawlStatus: {
    methodKind: "unary";
    input: typeof GetCrawlStatusRequestSchema;
    output: typeof GetCrawlStatusResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CrawlService.ListJobs
   */
  listJobs: {
    methodKind: "unary";
    input: typeof ListJobsRequestSchema;
    output: typeof ListJobsResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CrawlService.RetryDeadJobs
   */
  retryDeadJobs: {
    methodKind: "unary";
    input: typeof RetryDeadJobsRequestSchema;
    output: typeof RetryDeadJobsResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.CrawlService.PauseSource
   */
  pauseSource: {
    methodKind: "unary";
    input: typeof PauseSourceRequestSchema;
    output: typeof PauseSourceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_amrec_v1_crawl, 0);

